/**
 * KAN-1003: публичные цены сервиса (без входа).
 *
 *   GET /api/v1/public/prices/ - валюта, границы одного платежа и цены ресурсов
 *
 * apiClient ходит на тот же origin (baseURL пустой), поэтому путь полный, как у
 * остальных клиентов (wallet.ts и др.).
 */
import apiClient from './client';
import type { PublicPrices } from '@/types/publicPrices';

export const PUBLIC_PRICES_URL = '/api/v1/public/prices/';

export const publicPricesApi = {
  getPrices: async (): Promise<PublicPrices> =>
    (await apiClient.get<PublicPrices>(PUBLIC_PRICES_URL)).data,
};
